import { v1Theme } from './v1-theme/v1.theme';
export var theme = v1Theme;